import { Avatar, Button, IconUserOutlined, Typography, cn } from '@up-riac/bespoke-ui';
import React, { useContext } from 'react';
import { AccountHeaderContext } from 'src/lib/AccountHeaderContext';
import { LoginContext } from 'src/lib/LoginContext';

export const HeaderAccountProfileSection = ({
  id, onClose, currentPage, noBorderBottom,
}: {
  id: string, onClose: () => void, currentPage: 'login' | string, noBorderBottom?: boolean,
}): JSX.Element => {
  const { isLoggedIn, logout } = useContext(LoginContext);
  const { firstName, lastName, email } = useContext(AccountHeaderContext);
  return (
    <div className='px-5 flex flex-col gap-1' id={id}>
      {isLoggedIn ? <>
        <div className={cn(
          'flex flex-row gap-2 items-center border-b-1 border-b-neutral-400',
          noBorderBottom && 'border-b-0' || 'pb-5'
        )}>
          <Avatar className='shrink-0' id={`${id}-avatar`}>
            {firstName ? `${firstName.trim().substring(0, 1)}${lastName ? lastName.trim().substring(0, 1) : ''}` : <IconUserOutlined />}
          </Avatar>
          <div className='flex flex-col flex-1 min-w-0'>
            <div className='flex flex-row gap-1 justify-between items-end'>
              <Typography weight='semibold' className='text-text-contrast truncate grow' id={`${id}-name`}>
                {firstName} {lastName} {!firstName ? '...' : ''}
              </Typography>
              <div className='max-h-6 pr-1'>
                <Button id={`${id}-logout`} className='-mt-[5px]' variant='accent' size='sm' buttonType='ghost' onPress={logout}>
                  Log out
                </Button>
              </div>
            </div>
            <Typography size='sm' className='text-neutral-700 truncate pr-2' id={`${id}-email`}>{email || '...'}</Typography>
          </div>
        </div>
      </> : <>
        <div className='border-b-1 border-b-neutral-400 pb-3 pl-2'>
          <div className='flex flex-row gap-1 justify-between items-end'>
            <Typography weight='extrabold' heading className='text-text-contrast-light'>My account</Typography>
            <div className='max-h-6 pr-1'>
              <Button id={`${id}-create-account`} className='-mt-[5px]' variant='accent' size='sm' buttonType='ghost' to='/create-account' onPress={onClose}>
                Create account
              </Button>
            </div>
          </div>
          <Typography id={`${id}-description`} weight='medium' className='text-neutral-600 pr-2'>
            {currentPage === 'login' ? 'Log in or create an account.' : 'View your account details and settings.'}
          </Typography>
        </div>
      </>}
    </div>
  );
};
